import { useTranslation } from 'react-i18next';

import Text from '~/components/Text';
import UpgradePageLink from '~/components/UpgradePageLink';
import type { Publication } from '~/interfaces/publication';
import type { Subscription } from '~/interfaces/subscriptions';

import SidePanelLink from './SidePanelLink';
import SidePanelTitle from './SidePanelTitle';

interface Props {
  isPremiumEnabled: boolean;
  isLoggedIn?: boolean;
  isReferralEnabled: boolean;
  publication: Publication;
  subscription?: Subscription;
}

const GeneralNavGroup = ({ isPremiumEnabled, isLoggedIn, isReferralEnabled, publication, subscription }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <SidePanelTitle text={t('nav.mobile_sections.account')} />
      <div className="mb-2 flex flex-col">
        {isPremiumEnabled && (
          <UpgradePageLink href={publication.web_template.external_upgrade_page_href}>
            <Text
              as="span"
              type="body"
              theme="navs"
              weight="medium"
              className={'text-sm opacity-75 hover:text-wt-primary'}
            >
              {t('nav.links.upgrade')}
            </Text>
          </UpgradePageLink>
        )}
        {isLoggedIn && subscription && (
          <SidePanelLink path={`/subscribe/${subscription?.subscriber_id || ''}/manage`} text={t('nav.links.manage')} />
        )}
        {isReferralEnabled && subscription && (
          <SidePanelLink
            path={`/subscribe/${subscription?.subscriber_id || ''}/referrals`}
            text={t('nav.links.referrals')}
          />
        )}
      </div>
    </div>
  );
};

export default GeneralNavGroup;
